import React from 'react';
import {Platform} from 'react-native';
import {VictoryLabel} from 'victory-native';

import {styles} from './WeightTileGraphLabel.style';

type WeightTileGraphLabelProps = {
  text: string;
  x: number;
  y: number;
};

const WeightTileGraphLabel: React.FC<WeightTileGraphLabelProps> = ({
  text,
  x,
  y,
  ...props
}: WeightTileGraphLabelProps) => {
  const isWeb = Platform.OS === 'web';

  return (
    <VictoryLabel
      text={text}
      x={x}
      y={y}
      textAnchor="middle"
      dy={10}
      style={{
        ...styles.WeightTileGraphLabel,
        fontSize: isWeb ? 14 : 12,
      }}
      {...props}
    />
  );
};

export default WeightTileGraphLabel;
